<template>
  <nav class="section-tabs">
    <router-link
      v-for="tab in tabs"
      :key="tab.name"
      :to="{ name: tab.name }"
      class="section-tabs__item"
      :class="{ active: (tab.routes || [tab.name]).includes($route.name) }"
    >
      {{ tab.label }}
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "SectionTabs",
  props: {
    // [{ name: route name, label, routes?: route names that also mark the tab as active }]
    tabs: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.section-tabs {
  // Baseline drawn as an inset shadow so the active underline can cover it
  // without overflowing the scroll box (which would show a vertical scrollbar)
  box-shadow: inset 0 -2px 0 $grey7;
  display: flex;
  margin-bottom: 32px;
  overflow-x: auto;
  overflow-y: hidden;

  &__item {
    border-bottom: 3px solid transparent;
    color: $grey4;
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 600;
    padding: 12px 20px;
    transition: color 0.2s, border-color 0.2s;
    white-space: nowrap;

    &:hover {
      color: $purple;
      text-decoration: none;
    }

    &.active {
      border-bottom-color: $purple;
      color: $purple;
    }
  }
}
</style>
